import(/* webpackMode: "eager" */ "/vercel/path0/app/genre-generator/page.tsx")